import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import { useTranslation } from 'react-i18next';

const DefaultLanguageField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const { t: tForm } = useTranslation('form');
	const defaultLanguageName = tForm(customerForFullInfo?.defaultLanguageName || '');

	return <FullInfoField label="defaultLanguageLabel" value={defaultLanguageName} />;
};

export default DefaultLanguageField;
